// ENUMS ##########################################################
export enum CheckboxSizeEnum {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large'
}

// DECLARATIONS ###################################################


// INTERFACES #####################################################


// TYPES ##########################################################


// CLASSES ########################################################
